module.exports = __webpack_public_path__ + "img/course_002.4bf9053.png";